var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 367.21 59.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #000;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: #ff5300;\n        font-family: Montserrat-MediumItalic, Montserrat;\n        font-size: 53.26px;\n        font-style: italic;\n        font-weight: 500;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -364.36,
    y1: 18.33,
    x2: -384.9,
    y2: 23.09,
    gradientTransform: "translate(428.44 21.94) rotate(.05) scale(1.02 .98) skewX(-2.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b03ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7c1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a4265f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c5363d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#de4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f04b0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fb5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -369.38,
    y1: 3.15,
    x2: -390.05,
    y2: 7.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -361.44,
    y1: 2.89,
    x2: -427.72,
    y2: -29.71,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.4,44.64l14.03-36.75,6.99.02-14.03,36.75-6.99-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.18,22.2c-.36-1.91-1.32-3.36-2.86-4.34-1.55-.98-3.56-1.48-6.03-1.49-2.47,0-4.82.45-7.05,1.38-1.22.51-2.36,1.18-3.43,2.01l1.17-3.09-6.4-.02-10.66,28.04,6.72.02,5.59-14.54c1.06-2.73,2.51-4.76,4.36-6.09,1.85-1.33,4.01-1.99,6.48-1.98,2.37,0,3.89.65,4.56,1.93.67,1.28.57,3.06-.3,5.33l-5.84,15.38,6.72.02,5.92-15.54c1.06-2.76,1.41-5.1,1.05-7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.28,49.91c1.29,0,2.37-.35,3.23-1.07.86-.72,1.61-1.86,2.25-3.44l10.94-28.67,6.72.02-10.92,28.56c-2.55,6.68-6.94,10.02-13.18,10.01-1.33,0-2.52-.14-3.59-.4-.39-.1-.76-.21-1.11-.35l1.73-4.93s2.41.27,3.92.27ZM170.35,12.12c-1.22,0-2.13-.36-2.74-1.08-.61-.72-.82-1.59-.64-2.6.21-1.19.81-2.19,1.79-2.99.98-.8,2.16-1.2,3.52-1.2,1.18,0,2.09.35,2.72,1.03.63.68.86,1.52.69,2.5-.23,1.3-.83,2.35-1.79,3.15-.97.8-2.15,1.2-3.55,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.63,44.81l10.66-28.04,6.72.02-10.66,28.04-6.72-.02ZM186,12.16c-1.22,0-2.13-.36-2.74-1.08-.61-.72-.82-1.59-.64-2.6.21-1.19.81-2.19,1.79-2.99.98-.8,2.16-1.2,3.52-1.2,1.18,0,2.09.35,2.72,1.03.63.68.86,1.52.69,2.5-.23,1.3-.83,2.35-1.79,3.15-.97.8-2.15,1.2-3.55,1.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.2,29.34c-1.49,0-2.87.88-3.48,2.23l-2.92,6.52c-.6,1.35-1.98,2.23-3.48,2.23l-53.87-.03L0,51.27l54.4.03c1.53,0,2.94-.93,3.51-2.32l2.62-6.3c.58-1.39,1.98-2.32,3.51-2.32h12.05s4.48-11.02,4.48-11.02h-12.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.11,34.78c1.53,0,2.94-.93,3.51-2.32l2.62-6.3c.58-1.39,1.98-2.32,3.51-2.32l20.05.02,4.48-11.03-20.37-.02c-1.49,0-2.87.88-3.48,2.23l-2.92,6.52c-.6,1.35-1.98,2.23-3.48,2.23l-45.87-.03-4.46,10.99,46.4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.01,18.32c2.13,0,4.09-1.26,4.95-3.17l3.52-7.86-42.61-.02-4.48,11.03,38.62.02Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(191.42 44.87) rotate(.14) scale(1.02 .99) skewX(-7.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Verify "))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe9bc1161fa8766056bdbe740bc7e9ff.svg";
export { ForwardRef as ReactComponent };